import * as pdfLabelSettingsService from '../../../services/Administration/pdfSettingsService';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import Network from 'infrastructure/js/modules/network';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_IN_PROGRESS: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_IN_PROGRESS',
  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_FINISHED: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_FINISHED',

  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_IN_PROGRESS: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_IN_PROGRESS',
  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FINISHED: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FINISHED',
  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FAILED: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FAILED',

  ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_RESET_DATA: 'ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_RESET_DATA',
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  fetchDataInProgress: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_IN_PROGRESS, payload: payload};
  },
  fetchDataFinished: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_FINISHED, payload: payload};
  },
  submitInProgress: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_IN_PROGRESS, payload: payload};
  },
  submitFinished: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FINISHED, payload: payload};
  },
  submitFailed: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FAILED, payload: payload};
  },
  resetState: function (payload) {
    return {type: actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_RESET_DATA, payload: payload};
  },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.load = function () {
  return function (dispatch, getState) {
    return api.fetchData(dispatch, getState)();
  }
};

jsxActions.submit = function (data, messageDialogBuilder) {
  return function (dispatch, getState) {
    return api.submit(dispatch, getState)(data, messageDialogBuilder);
  }
};

jsxActions.preview = function () {
  return function (dispatch, getState) {
    return api.preview(dispatch, getState)();
  }
};

jsxActions.unmount = function () {
  return function (dispatch) {
    dispatch(actions.resetState());
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchData = function (dispatch, getState) {
  return function () {
    dispatch(actions.fetchDataInProgress());

    return pdfLabelSettingsService.fetchPdfDetailedLabelSettings()
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Failed to fetch Kit Detailed PDF Label Settings');
          messageDialogApi.responseError(dispatch, getState)(response);
          dispatch(actions.fetchDataFinished());
          return {success: false};
        }

        let labels = createLabelHelper('');

        let headerOptions = (response.data.headerOptions || []).map((item) => {
          let label = item.labelKey ? labels.get(item.labelKey) : item.name;
          return {value: item.id, label: label, data: item};
        });

        let rowOptions = (response.data.rowOptions || []).map((item) => {
          let label = item.labelKey ? labels.get(item.labelKey) : item.name;
          return {value: item.id, label: label, data: item};
        });

        let data = {
          headerFormData: {
            pdfOptions: headerOptions,
            pdfData: {
              settings: response.data.headerSettings,
            },
          },
          rowFormData: {
            pdfOptions: rowOptions,
            pdfData: {
              settings: response.data.rowSettings,
            },
          },
        };

        dispatch(actions.fetchDataFinished(data));

        return {success: true};
      });
  }
};

api.submit = function (dispatch, getState) {
  return function (data, messageDialogBuilder) {
    dispatch(actions.submitInProgress());

    return pdfLabelSettingsService.setPdfDetailedLabelSettings(data)
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Failed to update Kit Detailed PDF Label Settings', response);
          dispatch(actions.submitFailed());
          messageDialogApi.responseError(dispatch, getState)(response);
          return {success: false};
        }

        if (messageDialogBuilder) {
          let messageDialogDescriptor = messageDialogBuilder(response.data);
          messageDialogApi.open(dispatch, getState)(messageDialogDescriptor);
        }

        dispatch(actions.submitFinished(response.data));

        return api.fetchData(dispatch, getState)();
      });
  }
};

api.preview = function (dispatch, getState) {
  return function () {
    return pdfLabelSettingsService.previewPdfDetailedLabel({})
      .then((response) => {
        response.blob().then((blobResponse) => {
          if (blobResponse.size === 0) {
            console.error('Pdf Detailed Labels preview failed');
            messageDialogApi.responseError(dispatch, getState)();
            return {success: false};
          }

          let myURL = window.URL || window.webkitURL;
          let file = new Blob([blobResponse], {type: 'application/pdf'});
          let fileURL = myURL.createObjectURL(file);
          window.open(fileURL, '_blank');
        });
      })
      .catch((err) => {
        console.error('Pdf Detailed Labels preview catch ', err);
        messageDialogApi.responseError(dispatch, getState)();
        return {success: false};
      })
  }
};
